import { footerData } from '@/mocks/home';

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-950 text-foreground-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-18">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-accent-500 rounded-lg">
                <i className="ri-movie-2-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-heading text-foreground-50">天堂影院</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {footerData.description}
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-100 mb-4">快速导航</h3>
            <ul className="space-y-2">
              {[
                { label: '精选专题', href: '#carousel' },
                { label: '最新动态', href: '#updates' },
                { label: '热门排行', href: '#ranking' },
                { label: '影视大全', href: '#index' },
                { label: '常见问题', href: '#faq' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                    className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-100 mb-4">特色推荐</h3>
            <ul className="space-y-2">
              {[
                { label: '蓝光合集', href: '#cards' },
                { label: '精彩预告', href: '#media' },
                { label: '热门话题', href: '#topics' },
                { label: '用户评价', href: '#comments' },
                { label: '移动观影', href: '#app' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                    className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-100 mb-4">合作伙伴</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              诚挚感谢各位合作伙伴对天堂影院的支持与信任。期待与更多优质内容方携手，为广大影迷提供更丰富的高清影视在线播放体验。
            </p>
            <h3 className="text-sm font-semibold text-foreground-100 mb-4 mt-6">联系我们</h3>
            <div className="space-y-2 text-sm text-foreground-400">
              <p>邮箱：feedback@tiantangcinema.com</p>
              <p>微信：tiantangcinema</p>
              <p>QQ群：88886666</p>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 天堂影院 - 高清不缓冲 流畅在线观看 版权所有
          </p>
          <p className="text-xs text-foreground-600">
            本站内容仅供学习交流，请在24小时内删除
          </p>
        </div>
      </div>
    </footer>
  );
}